<template lang="pug">
.alert.alert-danger.alert-dismissible(v-if="error")
  button.close(type='button', @click="close") ×
  div
    i.icon.fas.fa-ban
    | {{msg}}
</template>

<script>
import Vue from 'vue'

export default {
  data(){
    return {
      error: false
    }
  },
  props: {
    msg: String
  },
  methods: {
    close(){
      this.error = false
    },
  },
  async mounted(){
    await Vue.nextTick()
    this.error = true
  },
}
</script>
<style lang="scss" scoped>
</style>
